export const stateData = {
  //delhi-assembly
  "delhi-assembly": {
    breadCrump: [
      {
        displayText: "खबरें",
        url: "/elections/delhi-assembly",
        keyToShow: "",
      },
      {
        displayText: "निर्वाचन क्षेत्र",
        url: "/elections/delhi-assembly/constituency-list",
        keyToShow: "",
      },

      {
        displayText: "प्रमुख उम्मीदवार",
        url: "/elections/delhi-assembly/key-candidates-list",
        keyToShow: "",
      },
      {
        displayText: "चुनाव परिणाम",
        url: "/elections/delhi-assembly/results",
        keyToShow: "",
      },
      {
        displayText: "एग्जिट पोल",
        url: "/elections/delhi-assembly/exit-poll-result",
        keyToShow: "",
      },

      {
        displayText: "शेड्यूल",
        url: "/elections/delhi-assembly/schedule",
        keyToShow: "",
      },
    ],
    masterConfigKey: "delhi_election",
    electionPassedCategory: "delhi-assembly",
    state: "Delhi",
    stateHindi: "दिल्ली",
    metaData: {
      title: `Delhi Chunav 2025: दिल्ली विधानसभा चुनाव 2025, Delhi Vidhan Sabha Elections, News & Schedule - NewsTak`,
      description: `Delhi Election: Know the latest updates on Delhi Assembly Election 2025, दिल्ली विधानसभा चुनाव, Schedule, exit poll, election results, वोटों की गिनती, चुनाव समाचार, पार्टी परिणाम, वीडियो, फोटो, विजेता उम्मीदवारों, विधानसभा चुनाव नतीजे का कवरेज, news in hindi at NewsTak.in`,
      keywords: `Delhi Election, Delhi Vidhan Sabha Chunav, 2025 India elections, delhi assembly election date, Delhi Vidhan Sabha Chunav news in hindi, Delhi Chunav news in hindi, दिल्ली चुनाव,दिल्ली चुनाव समाचार, दिल्ली विधानसभा चुनाव, दिल्ली इलेक्शन`,
    },
    "exit-poll-result": {
      electionPassedCategory: "delhi-assembly",
      metaData: {
        title: `Exit Poll 2025 : Delhi Assembly Election Exit poll, दिल्ली विधानसभा चुनाव एग्जिट पोल्स - NewsTak.in`,
        description: `Delhi Vidhan Sabha Chunav Exit Polls: Find the latest Delhi Assembly Election exit polls, including दिल्ली इलेक्शन एग्जिट पोल्स, दिल्ली चुनाव एग्जिट पोल्स, and दिल्ली विधानसभा इलेक्शन एग्जिट पोल्स. Stay updated with the latest news on Delhi Assembly Chunav Exit Polls from NewsTak.`,
        keywords: `Delhi Assembly Election Exit poll, 2025 Delhi Assembly Election Exit poll, exit poll Delhi, exit poll results, Delhi vidhan sabha exit poll, Delhi exit poll, Delhi election result exit poll, Delhi assembly, Delhi election news, Delhi vidhan sabha election exit poll, Delhi latest exit poll, exit poll of Delhi, Delhi 2025 exit poll, Delhi exit poll vidhan sabha 2024, Delhi vidhan sabha, Delhi exit poll result,`,
      },
      state: "Delhi",
      stateHindi: "दिल्ली",
      agencyName: "AgencyDL",

      exitDesc2019:
        "दिल्ली विधानसभा चुनाव 2019 के नतीजे 21 दिसंबर को आने वाले हैं, लेकिन उससे पहले एग्जिट पोल पर सबकी नजर है. दिल्ली चुनाव में सत्ताधारी बीजेपी के अलावा मुख्य विपक्षी कांग्रेस संग जेजेपी, आईएनएलडी और बसपा जैसी पार्टियां अपनी किस्मत आजमा रही हैं. इस बार का चुनाव किसानों के मुद्दे, रोजगार और महंगाई जैसे इश्यू पर लड़ा गया. बीजेपी को 10 सालों की एंटी इनकंबेंसी का भी सामना करना पड़ेगा. एग्जिट पोल से झारखंड चुनाव के संभावित नतीजों के बारे में पता चलता है. एग्जिट पोल के डेटा को वोटिंग के आखिरी दिन ही जारी किया जाता है. इसके लिए डेटा कलेक्शन वोटिंग के दिन किया जाता है. वोटिंग के दिन जब वोटर्स वोट डालकर बाहर आते हैं तो उनसे सवाल पूछकर नब्ज टटोली जाती है.",
      exitDesc2024:
        "दिल्ली विधानसभा चुनाव 2024 के नतीजे 23 नवंबर को जारी होंगे. उससे पहले एग्जिट पोल पर सबकी नजर है. कुल 81 विधानसभा सीटों के लिए 1,211 उम्मीदवार मैदान में हैं. इसमें इंडिया ब्लॉक की तरफ से झामुमो के 43, कांग्रेस के 30, राजद के 6 और भाकपा-माले के 4 उम्मीदवारों के अलावा NDA के सहयोगी दल बीजेपी के 68, ऑल झारखंड स्टूडेंट्स यूनियन (AJSU) के 10, चिराग पासवान की पार्टी लोक जनशक्ति पार्टी (रामविलास) का 1 और नीतीश कुमार की जेडीयू (JDU) के 2 उम्मीदवार चुनावी समर में अपना भाग्य आजमा चुके हैं. चुनावी नतीजे ईवीएम में कैद हो चुके हैं. एग्जिट पोल से झारखंड चुनाव के संभावित नतीजों के बारे में पता चलता है. एग्जिट पोल के डेटा को वोटिंग के आखिरी दिन ही जारी किया जाता है. इसके लिए डेटा कलेक्शन वोटिंग के दिन किया जाता है. वोटिंग के दिन जब वोटर्स वोट डालकर बाहर आते हैं तो उनसे सवाल पूछकर जनता की नब्ज टटोली जाती है.",
      currentYear: "2024",
      2019: {
        type: "static",
        data: [
          {
            agency: "AgencyDL",
            pollData: [
              {
                agencyName: "CVoter",
                partyData: [
                  {
                    partyName: "BJP",
                    seats: "20-28",
                    midRange: 24,
                  },
                  {
                    partyName: "CONG+",
                    seats: "50-58",
                    midRange: 54,
                  },
                  {
                    partyName: "OTH",
                    seats: "10-16",
                    midRange: 13,
                  },
                ],
              },
            ],
            totalSeats: 70,
          },
        ],
      },
      2024: {
        type: "api",
        data: "https://elections.mobiletak.com/jsonfiles/exitpolls/assemblyPollData.json",
        dataKey: "AgencyDL",
      },
      // "assemblyPollData": "https://elections.mobiletak.com/jsonfiles/exitpolls/assemblyPollData.json"
    },
    "key-candidates-list": {
      metaData: {
        title: ` Key Candidates of Delhi Assembly Election 2025, दिल्ली चुनाव के प्रमुख उम्मीदवार - NewsTak`,
        description: `Get the list of Delhi Assembly Election 2025 Key candidates (दिल्ली विधानसभा चुनाव के प्रमुख उम्मीदवार), including party-wise candidates, constituencies, चुनाव समाचार and other key information in Hindi at NewsTak.in.`,
        keywords: ` Delhi Assembly Election 2024 Key Candidate, Delhi Election 2024 Key Candidate, Delhi vidhan sabha chunav 2025 Candidate, Delhi Chunav candidate list, दिल्ली विधानसभा चुनाव 2025 उम्मीदवारों की सूची, Vidhan Sabha Election Candidate, दिल्ली चुनाव के प्रमुख उम्मीदवार`,
      },
      electionPassedCategory: "delhi-assembly",
      dataUrl:
        "https://electionresults.intoday.in/elections/2024/assembly-elections/json/ei-dashboard/2024/key-candidate/delhi-key-candidate.json",
      dataKey: "Delhi",
      dataUrlKey: "DL_KeyCandidatesURL",
      stateName: "Delhi",
      stateNameHi: "दिल्ली",
      electionYear: "2024",
    },

    schedule: {
      electionPassedCategory: "delhi-assembly",
      state: "Delhi",
      stateHindi: "दिल्ली",
      electionYear: "2025",
      metaData: {
        title: ` Delhi Assembly Election Schedule: दिल्ली विधानसभा चुनाव तिथि 2025, Delhi Election Schedule 2025 - NewsTak.in`,
        description: `Delhi Vidhan Sabha Chunav Schedule 2025 : NewsTak.in provides the essential information for Delhi Assembly Election (दिल्ली विधानसभा चुनाव 2024 कार्यक्रम). Get details on dates, polling locations, and important announcements related to Delhi vidhan sabha election.`,
        keywords: ` Delhi Assembly Election Schedule 2025, विधानसभा चुनाव 2025 कार्यक्रम, Delhi election dates, दिल्ली विधानसभा चुनाव, polling information, Delhi election updates, Delhi voter guide, Delhi politics, Delhi vidhan sabha elections, assembly election full schedule, दिल्ली विधानसभा चुनाव तिथि, दिल्ली चुनाव समाचार`,
      },
      votingDate: "05 फरवरी 2025",
      resultDate: "08 फरवरी 2025",
      scheduleDesc: `दिल्ली की 70 विधानसभा सीटों के लिए चुनाव फरवरी 2025 में एक ही चरण में होने की संभावना है। चुनाव आयोग के अनुसार, मतदान 05 फरवरी को आयोजित किया जाएगा। मतगणना 08 फरवरी को होगी और इसी दिन चुनाव परिणाम घोषित किए जाएंगे।`,
    },
    results: {
      metaData: {
        title: ` Delhi Assembly Election Results 2025: दिल्ली विधानसभा चुनाव परिणाम, Delhi Chunav Results 2025 - NewsTak.in`,
        description: `Delhi Vidhan Sabha Chunav Results 2025 : Delhi Election Results, NewsTak पर जाने दिल्ली विधानसभा चुनाव परिणाम 2025, चुनाव विश्लेषण, वोटों की गिनती, चुनाव समाचार, पार्टी परिणाम, वीडियो, फोटो, विजेता उम्मीदवारों, विधानसभा चुनाव नतीजे का कवरेज`,
        keywords: ` elections, Delhi Chunav results live, election results, Delhi Assembly election results, Delhi election results live, Delhi assembly Election 2025 Result, counting of votes for Delhi Assembly Election, Delhi Assembly Election Results live, Delhi election results, congress results updates, दिल्ली विधानसभा चुनाव, 2025 दिल्ली विधानसभा चुनाव परिणाम, चुनाव परिणाम, विधानसभा चुनाव परिणाम, चुनाव 2025, विधानसभा चुनाव 2024 परिणाम`,
      },
      electionPassedCategory: "delhi-assembly",
      state: "Delhi",
      stateHindi: "दिल्ली",
      currentYear: "2024",
      oldResult: {
        partyData: [
          {
            color: "#FF9933",
            partyName: "BJP",
            partySeat: "48",
          },
          {
            color: "#19AAED",
            partyName: "AAP",
            partySeat: "22",
          },
          {
            color: "#19AAED",
            partyName: "INC",
            partySeat: "00",
          } 
            
        ],
      },
      resultKey: "partiesDataDL",
      oldDesc:
        "Delhi Assembly Elections Results 2024: इस बार के झारखंड विधानसभा चुनाव में चल रही है किसकी हवा? JMM-कांग्रेस का INDIA गठबंधन बचा लेगा अपनी सरकार या BJP-AJSU वाला NDA गठबंधन मार ले जाएगा बाजी? सबसे सटीक और तेज नतीजों के लिए बने रहिए न्यूज Tak के साथ. नीचे दी गई लिस्ट में जानिए क्या रहा था झारखंड विधानसभा चुनाव 2019 का रिजल्ट.",
      newDesc:
        "Delhi Assembly Elections Results 2025:  इस बार के दिल्ली विधानसभा चुनाव में कौन मारेगा बाजी? आम आदमी पार्टी (AAP) लगातार चौथी बार बनाएगी सरकार या भारतीय जनता पार्टी (BJP) को मिलेगा जनता का साथ या कांग्रेस (Congress) कर सकती है कमाल? सबसे सटीक और तेज नतीजों के लिए बने रहिए न्यूज Tak के साथ. ",
      prevDataUrl:
        "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/delhi-2014-all-consituency.json",
      currentDataUrl:
        "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/delhi-2019-all-consituency.json",
      2014: "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/delhi-2014-all-consituency.json",
      2019: "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/delhi-2019-all-consituency.json",
      // "2024" : "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/jharkhand-2019-all-consituency.json",
      2024: "https://electionresults.intoday.in/elections/2024/assembly-elections/json/state/delhi-all-consituency.json",
      constituency: {
        //this is used in url
        state: "Delhi",
        stateHindi: "दिल्ली",
        url3Key: "ConstituencyDetailURL",
        url: "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/constituency/jharkhand/",
        // "url3": "https://electionresults.intoday.in/elections/2024/assembly-elections/json/constituency-tak/7047",
        url3: "https://electionresults.intoday.in/elections/2024/assembly-elections/json/constituency-tak/",
        url2: "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/jharkhand-state-master.json",
      },
    },
    "constituency-list": {
      electionPassedCategory: "delhi-assembly",
      state: "Delhi",
      stateHindi: "दिल्ली",
      currentYear: "2024",
      staticContent:`इस बार के दिल्ली विधानसभा चुनाव में कौन मारेगा बाजी? आम आदमी पार्टी (AAP) लगातार चौथी बार बनाएगी सरकार या भारतीय जनता पार्टी (BJP) को मिलेगा जनता का साथ या कांग्रेस (Congress) कर सकती है कमाल? सबसे सटीक और तेज नतीजों के लिए बने रहिए न्यूज Tak के साथ.`,
      metaData: {
        title: `Delhi Assembly Election 2025: Delhi Chunav Constituency List, दिल्ली विधानसभा निर्वाचन क्षेत्र सूची - NewsTak`,
        description: `Delhi Assembly Election Constituency: Get the complete list of Delhi Vidhan Sabha constituencies, दिल्ली विधानसभा चुनाव निर्वाचन क्षेत्र, पार्टी उम्‍मीदवार, चुनाव की खबरें, फोटो एवं वीडियो, Delhi Chunav updates and दिल्ली चुनाव समाचार at NewsTak.in`,
        keywords: `Delhi Assembly Election, Delhi Vidhan Sabha Constituency List, दिल्ली विधानसभा चुनाव, दिल्ली चुनाव समाचार, Delhi Chunav Constituencies list, दिल्ली विधानसभा चुनाव निर्वाचन क्षेत्र, दिल्ली विधानसभा निर्वाचन क्षेत्र, delhi news, दिल्ली विधानसभा समाचार`,
      },
      constituency_urls: {
        //this is used in url
        state: "Delhi",
        stateHindi: "दिल्ली",
        url3Key: "ConstituencyDetailURL",
        url: "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/constituency/delhi/",

        url3: "https://electionresults.intoday.in/elections/2024/assembly-elections/json/constituency-tak/",
        url2: "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/delhi-state-master.json",
      },
    },
    constituencies: {
      electionPassedCategory: "delhi-assembly",
      state: "Delhi",
      stateHindi: "दिल्ली",
      currentYear: "2024",
    },
    candidates: {
      electionPassedCategory: "delhi-assembly",
      state: "Delhi",
      stateHindi: "दिल्ली",
      currentYear: "2024",
    },
    tallyState: "delhi",
  },

  //  haryana
  "haryana-assembly": {
    breadCrump: [
      {
        displayText: "खबरें",
        url: "/elections/haryana-assembly",
        keyToShow: "",
      },
      {
        displayText: "निर्वाचन क्षेत्र",
        url: "/elections/haryana-assembly/constituency-list",
        keyToShow: "",
      },

      {
        displayText: "प्रमुख उम्मीदवार",
        url: "/elections/haryana-assembly/key-candidates-list",
        keyToShow: "",
      },
      {
        displayText: "चुनाव परिणाम",
        url: "/elections/haryana-assembly/results",
        keyToShow: "",
      },
      {
        displayText: "एग्जिट पोल",
        url: "/elections/haryana-assembly/exit-poll-result",
        keyToShow: "",
      },

      {
        displayText: "शेड्यूल",
        url: "/elections/haryana-assembly/schedule",
        keyToShow: "",
      },
    ],
    masterConfigKey: "haryana_election",
    electionPassedCategory: "haryana-assembly",
    state: "Haryana",
    stateHindi: "हरियाणा",
    masterConfigKey: "haryana_election",
    metaData: {
      title: `2024 Haryana Vidhan Sabha Chunav: Haryana Assembly Chunav 2024, हरियाणा विधानसभा चुनाव, Haryana Elections Updates - NewsTak`,
      description: `Haryana Assembly Elections 2024: Find the latest updates on the 2024 Haryana Assembly Chunav (हरियाणा विधानसभा चुनाव 2024), including voting dates, exit polls, election results, candidate profiles, photos, videos of हरियाणा चुनाव 2024, and expert analysis at NewsTak.`,
      keywords: `Keywords: haryana chunav 2024, हरियाणा विधानसभा चुनाव breaking News, haryana assembly election 2024, haryana assembly election news in hindi,हरियाणा विधानसभा चुनाव परिणाम 2024, हरियाणा चुनाव 2024, हरियाणा चुनाव समाचार, हरियाणा विधानसभा चुनाव समाचार`,
    },
    "exit-poll-result": {
      electionPassedCategory: "haryana-assembly",
      metaData: {
        title: `Exit poll 2024 Live : Haryana Assembly Election Exit poll, हरियाणा विधानसभा चुनाव एग्जिट पोल्स - NewsTak.in`,
        description: `Haryana Vidhan Sabha Chunav Exit Polls: Find the latest Haryana Assembly Election exit polls, including हरियाणा इलेक्शन एग्जिट पोल्स, हरियाणा चुनाव एग्जिट पोल्स, and हरियाणा विधानसभा इलेक्शन एग्जिट पोल्स. Stay updated with the latest news on Haryana Assembly Chunav Exit Polls from NewsTak!`,
        keywords: `Haryana Assembly Election Exit poll, 2024 Haryana Assembly Election Exit poll, exit poll Haryana, exit poll results, Haryana vidhan sabha exit poll, haryana exit poll, haryana election result exit poll, haryana assembly, haryana election news, haryana vidhan sabha election exit poll, haryana latest exit poll, exit poll of Haryana, haryana 2024 exit poll, haryana exit poll vidhan sabha 2024, haryana vidhan sabha, haryana exit poll result,`,
      },
      state: "Haryana",
      stateHindi: "हरियाणा",
      agencyName: "AgencyHR",

      exitDesc2019:
        "हरियाणा विधानसभा चुनाव 2024 के नतीजे 8 अक्टूबर को आने वाले हैं, लेकिन उससे पहले एग्जिट पोल पर सबकी नजर है. हरियाणा चुनाव में सत्ताधारी बीजेपी के अलावा मुख्य विपक्षी कांग्रेस संग जेजेपी, आईएनएलडी और बसपा जैसी पार्टियां अपनी किस्मत आजमा रही हैं. इस बार का चुनाव किसानों के मुद्दे, रोजगार और महंगाई जैसे इश्यू पर लड़ा गया. बीजेपी को 10 सालों की एंटी इनकंबेंसी का भी सामना करना पड़ेगा. एग्जिट पोल से हरियाणा चुनाव के संभावित नतीजों के बारे में पता चलता है. एग्जिट पोल के डेटा को वोटिंग के आखिरी दिन ही जारी किया जाता है. इसके लिए डेटा कलेक्शन वोटिंग के दिन किया जाता है. वोटिंग के दिन जब वोटर्स वोट डालकर बाहर आते हैं तो उनसे सवाल पूछकर नब्ज टटोली जाती है.",
      exitDesc2024:
        "हरियाणा विधानसभा चुनाव 2024 के नतीजे 8 अक्टूबर को आने वाले हैं, लेकिन उससे पहले एग्जिट पोल पर सबकी नजर है. हरियाणा चुनाव में सत्ताधारी बीजेपी के अलावा मुख्य विपक्षी कांग्रेस संग जेजेपी, आईएनएलडी और बसपा जैसी पार्टियां अपनी किस्मत आजमा रही हैं. इस बार का चुनाव किसानों के मुद्दे, रोजगार और महंगाई जैसे इश्यू पर लड़ा गया. बीजेपी को 10 सालों की एंटी इनकंबेंसी का भी सामना करना पड़ेगा. एग्जिट पोल से हरियाणा चुनाव के संभावित नतीजों के बारे में पता चलता है. एग्जिट पोल के डेटा को वोटिंग के आखिरी दिन ही जारी किया जाता है. इसके लिए डेटा कलेक्शन वोटिंग के दिन किया जाता है. वोटिंग के दिन जब वोटर्स वोट डालकर बाहर आते हैं तो उनसे सवाल पूछकर नब्ज टटोली जाती है.",

      currentYear: "2024",
      2019: {
        type: "static",
        data: [
          {
            agency: "AgencyHR",
            pollData: [
              {
                agencyName: "India Today- Axis My India",
                partyData: [
                  {
                    partyName: "BJP",
                    seats: "109-124",
                    midRange: 116,
                    percentage: 48,
                  },
                  {
                    partyName: "SENA",
                    seats: "57-70",
                    midRange: 63,
                    percentage: 22,
                  },
                  {
                    partyName: "CONG",
                    seats: "32-40",
                    midRange: 36,
                    percentage: 12,
                  },
                  {
                    partyName: "NCP",
                    seats: "40-50",
                    midRange: 45,
                    percentage: 15,
                  },
                  {
                    partyName: "VBA",
                    seats: "00-02",
                    midRange: 1,
                    percentage: 1,
                  },
                  {
                    partyName: "OTH",
                    seats: "22-32",
                    midRange: 25,
                    percentage: 1,
                  },
                ],
              },
            ],
            totalSeats: 90,
          },
        ],
      },
      2024: {
        type: "api",
        data: "https://elections.mobiletak.com/jsonfiles/exitpolls/assemblyPollData.json",
        dataKey: "AgencyHR",
      },
      // "assemblyPollData": "https://elections.mobiletak.com/jsonfiles/exitpolls/assemblyPollData.json"
    },
    "key-candidates-list": {
      metaData: {
        title: `Key Candidates of Haryana Assembly Election 2024, हरियाणा चुनाव के प्रमुख उम्मीदवार - NewsTak`,
        description: `Get the list of Haryana Assembly Election 2024 Key candidates (हरियाणा चुनाव के प्रमुख उम्मीदवार), including party-wise candidates, constituencies, and other key information in Hindi at NewsTak.in.`,
        keywords: `Haryana Assembly Election 2024 Key Candidate, Haryana Election 2024 Key Candidate, haryana vidhan sabha chunav 2024 Candidate,haryana 2024 candidate list, हरियाणा विधानसभा चुनाव 2024 उम्मीदवारों की सूची, Vidhan Sabha Election Candidate`,
      },
      electionPassedCategory: "haryana-assembly",
      dataUrl:
        "https://electionresults.intoday.in/elections/2024/assembly-elections/json/ei-dashboard/2024/key-candidate/haryana-key-candidate.json",
      dataKey: "Haryana",
      dataUrlKey: "MH_KeyCandidatesURL",
      stateName: "Haryana",
      stateNameHi: "हरियाणा",
      electionYear: "2024",
    },

    schedule: {
      electionPassedCategory: "haryana-assembly",
      state: "Haryana",
      stateHindi: "हरियाणा",
      electionYear: "2024",
      metaData: {
        title: `Haryana Assembly Election Schedule | हरियाणा विधानसभा चुनाव तिथि 2024 | Election Schedule 2024 - NewsTak.in`,
        description: `Haryana Assembly election Schedule 2024 LIVE : NewsTak.in provides the essential information for हरियाणा विधानसभा चुनाव 2024 कार्यक्रम. Get details on dates, polling locations, and important announcements related to Haryana vidhan sabha election.`,
        keywords: `Haryana Assembly Election Schedule 2024, विधानसभा चुनाव 2024 कार्यक्रम, Haryana election dates, हरियाणा विधानसभा चुनाव, polling information, Haryana election updates, Haryana voter guide, Haryana politics,Haryana vidhan sabha elections, assembly election full schedule`,
      },
      votingDate: "5 अक्टूबर 2024",
      resultDate: "8 अक्टूबर 2024",
      scheduleDesc:
        "90 सदस्यीय हरियाणा विधानसभा के लिए 5 अक्टूबर को वोटिंग होगी और मतगणना 8 अक्टूबर को होगी. हरियाणा में सभी पार्टी जीत के लिए अपना पूरा दम लगाने में जुटी है. हरियाणा की सत्ता पर काबिज बीजेपी इस बार 89 सीटों पर चुनाव लड़ रही है. सिरसा सीट पर बीजेपी ने हरियाणा लोकहित पार्टी (HLP) के गोपाल कांडा को समर्थन दे दिया है. कांग्रेस ने एक सीट पर माकपा से गठबंधन किया है. आम आदमी पार्टी ने सभी 90 सीटों पर प्रत्याशी उतारे हैं. इंडियन नेशनल लोकदल और बसपा इस बार साथ मिलकर चुनाव लड़ रही है. INLD इस बार सिर्फ 30 सीटों पर चुनाव लड़ रही है. वहीं बहुजन समाज पार्टी 38 सीटों पर चुनाव लड़ रही है.",
    },
    results: {
      metaData: {
        title: `Election Results 2024 | हरियाणा विधानसभा चुनाव 2024 परिणाम | Haryana Assembly Election Results 2024 - NewsTak.in`,
        description: `Haryana Assembly election Results 2024 : Election Results, NewsTak पर जाने हरियाणा विधानसभा चुनाव परिणाम 2024, चुनाव विश्लेषण, वोटों की गिनती, चुनाव समाचार, पार्टी परिणाम, वीडियो, फोटो, विजेता उम्मीदवारों, विधानसभा चुनाव नतीजे का कवरेज`,
        keywords: `elections, election results, Haryana Assembly election results, Haryana election results, Haryana assembly Election 2024 Result, counting of votes for Haryana Assembly Election, congress results, Haryana election results, congress results updates, हरियाणा विधानसभा चुनाव, 2024 हरियाणा विधानसभा चुनाव परिणाम, चुनाव परिणाम, विधानसभा चुनाव परिणाम, चुनाव 2024, विधानसभा चुनाव 2024 परिणाम,`,
      },
      electionPassedCategory: "haryana-assembly",
      state: "Haryana",
      stateHindi: "हरियाणा",
      currentYear: "2024",
      oldResult: {
        partyData: [
          {
            color: "#FF9933",
            partyName: "Bharatiya Janata Party",
            partySeat: "105",
          },
          {
            color: "#19AAED",
            partyName: "Shiv Sena",
            partySeat: "56",
          },
          {
            color: "#19AAED",
            partyName: "Indian National Congress",
            partySeat: "44",
          },
          {
            color: "#71B218",
            partyName: "National Congress Party",
            partySeat: "54",
          },
          {
            color: "#CC0000",
            partyName: "OTH",
            partySeat: "9",
          },
        ],
      },
      resultKey: "partiesDataHR",
      oldDesc:
        "हरियाणा विधानसभा चुनाव 2024 (Haryana Assembly election 2024) होने वाले हैं. हरियाणा विधानसभा की 90 सीटों पर एक चरण में 8 अक्टूबर को वोटिंग होगी. अब बारी है इन चुनावी नतीजों की. न्यूज Tak की वेबसाइट newstak.in के इस खास सेक्शन में आप हर सीट पर विधानसभा चुनाव के पूरे नतीजे देख सकते हैं. हरियाणा में 2019 के विधानसभा चुनाव में भारतीय जनता पार्टी को 40 सीटों पर जीत मिली थी. बीजेपी अपने दम पर बहुमत हासिल नहीं कर पाई थी. कांग्रेस ने पिछले चुनावों से अच्छा प्रदर्शन करते हुए 30 सीटों पर जीत हासिल की थी. जेजेपी को 10 सीटों पर जीत मिली थी. बाद में बीजेपी ने जेजेपी के साथ मिलकर हरियाणा में सरकार बनाई थी. इंडियन नेशनल लोकदल को सिर्फ एक सीट पर जीत मिली थी. आप हरियाणा विधानसभा चुनाव के इस पेज पर चुनावी नतीजों के साथ सियासी उठापटक की भी लेटेस्ट खबरें देख सकते हैं. प्रदेश और देश की सियासत का हर पहलू समझने के लिए बनें रहें न्यूज Tak के साथ.",
      newDesc:
        "हरियाणा विधानसभा चुनाव 2024 (Haryana Assembly election 2024) होने वाले हैं. हरियाणा विधानसभा की 90 सीटों पर एक चरण में 8 अक्टूबर को वोटिंग होगी. अब बारी है इन चुनावी नतीजों की. न्यूज Tak की वेबसाइट newstak.in के इस खास सेक्शन में आप हर सीट पर विधानसभा चुनाव के पूरे नतीजे देख सकते हैं. हरियाणा में 2019 के विधानसभा चुनाव में भारतीय जनता पार्टी को 40 सीटों पर जीत मिली थी. बीजेपी अपने दम पर बहुमत हासिल नहीं कर पाई थी. कांग्रेस ने पिछले चुनावों से अच्छा प्रदर्शन करते हुए 30 सीटों पर जीत हासिल की थी. जेजेपी को 10 सीटों पर जीत मिली थी. बाद में बीजेपी ने जेजेपी के साथ मिलकर हरियाणा में सरकार बनाई थी. इंडियन नेशनल लोकदल को सिर्फ एक सीट पर जीत मिली थी. आप हरियाणा विधानसभा चुनाव के इस पेज पर चुनावी नतीजों के साथ सियासी उठापटक की भी लेटेस्ट खबरें देख सकते हैं. प्रदेश और देश की सियासत का हर पहलू समझने के लिए बनें रहें न्यूज Tak के साथ.",
      prevDataUrl:
        "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/haryana-2014-all-consituency.json",
      currentDataUrl:
        "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/haryana-2019-all-consituency.json",
      2014: "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/haryana-2014-all-consituency.json",
      2019: "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/haryana-2019-all-consituency.json",
      // "2024" : "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/haryana-2019-all-consituency.json",
      2024: "https://electionresults.intoday.in/elections/2024/assembly-elections/json/state/haryana-all-consituency.json",
      constituency: {
        //this is used in url
        state: "Haryana",
        stateHindi: "हरियाणा",
        url3Key: "ConstituencyDetailURL",
        url: "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/constituency/haryana/",
        // "url3": "https://electionresults.intoday.in/elections/2024/assembly-elections/json/constituency-tak/7047",
        url3: "https://electionresults.intoday.in/elections/2024/assembly-elections/json/constituency-tak/",
        url2: "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/haryana-state-master.json",
      },
    },
    "constituency-list": {
      electionPassedCategory: "haryana-assembly",
      state: "Haryana",
      stateHindi: "हरियाणा",
            staticContent:`इस बार के हरियाणा के विधानसभा चुनाव में चलेगा किसका सिक्का? BJP की फिर से बनेगी सरकार या कांग्रेस मार ले जाएगी बाजी? JJP और INLD के गठबंधनों का क्या है हाल? सबसे सटीक और तेज नतीजों के लिए बने रहिए न्यूज Tak के साथ.`,

      currentYear: "2024",
      metaData: {
        title: `Haryana Assembly Election 2024: Constituency Wise Candidate Winner List, 2024 हरियाणा विधानसभा चुनाव निर्वाचन क्षेत्र उम्मीदवार`,
        description: `Haryana Assembly Elections Results 2024 (हरियाणा विधानसभा चुनाव 2024 परिणाम) – Get the list of winning candidates from all major parties in the Haryana vidhan sabha election (विधानसभा चुनाव) 2024, along with live election news, videos, photos, and in-depth analysis on Haryana Election 2024.`,
        keywords: `Haryana Assembly Election  2024, 2024 Haryana vidhan sabha election winning candidates list, Constituency-wise vidhan sabha Winning Candidates list 2024, winning candidates list of Haryana Assembly election 2024, हरियाणा विधानसभा चुनाव 2024, हरियाणा विधानसभा चुनाव 2024 उम्मीदवारों की सूची,  list of winning candidate, election results, जीतने वाला उम्मीदवार 2024,`,
      },
      constituency_urls: {
        //this is used in url
        state: "Haryana",
        stateHindi: "हरियाणा",
        url3Key: "ConstituencyDetailURL",
        url: "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/constituency/haryana/",

        url3: "https://electionresults.intoday.in/elections/2024/assembly-elections/json/constituency-tak/",
        url2: "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/haryana-state-master.json",
      },
    },
    constituencies: {
      electionPassedCategory: "haryana-assembly",
      state: "Haryana",
      stateHindi: "हरियाणा",
      currentYear: "2024",
    },
    tallyState: "haryana",
  },

  //maharashtra
  "maharashtra-assembly": {
    breadCrump: [
      {
        displayText: "खबरें",
        url: "/elections/maharashtra-assembly",
        keyToShow: "",
      },
      {
        displayText: "निर्वाचन क्षेत्र",
        url: "/elections/maharashtra-assembly/constituency-list",
        keyToShow: "",
      },

      {
        displayText: "प्रमुख उम्मीदवार",
        url: "/elections/maharashtra-assembly/key-candidates-list",
        keyToShow: "",
      },
      {
        displayText: "चुनाव परिणाम",
        url: "/elections/maharashtra-assembly/results",
        keyToShow: "",
      },
      {
        displayText: "एग्जिट पोल",
        url: "/elections/maharashtra-assembly/exit-poll-result",
        keyToShow: "",
      },

      {
        displayText: "शेड्यूल",
        url: "/elections/maharashtra-assembly/schedule",
        keyToShow: "",
      },
    ],
    masterConfigKey: "maharashtra_election",
    electionPassedCategory: "maharashtra-assembly",
    state: "Maharashtra",
    stateHindi: "महाराष्ट्र",
    masterConfigKey: "maharashtra_election",
    metaData: {
      title: `2024 Maharashtra Vidhan Sabha Chunav: Maharashtra Assembly Chunav 2024, महाराष्ट्र विधानसभा चुनाव, Maharashtra Elections Updates - NewsTak`,
      description: `Maharashtra Assembly Elections 2024: Find the latest updates on the 2024 Maharashtra Assembly Chunav (महाराष्ट्र विधानसभा चुनाव 2024), including voting dates, exit polls, election results, candidate profiles, photos, videos of महाराष्ट्र चुनाव 2024, and expert analysis at NewsTak.`,
      keywords: `maharashtra chunav 2024, महाराष्ट्र विधानसभा चुनाव breaking News, maharashtra assembly election 2024, maharashtra assembly election news in hindi,महाराष्ट्र विधानसभा चुनाव परिणाम 2024, महाराष्ट्र चुनाव 2024, महाराष्ट्र चुनाव समाचार, महाराष्ट्र विधानसभा चुनाव समाचार`,
    },
    "exit-poll-result": {
      electionPassedCategory: "maharashtra-assembly",
      metaData: {
        title: `Exit Poll 2024 : Maharashtra Assembly Elections Exit poll, महाराष्ट्र विधानसभा चुनाव एग्जिट पोल्स - NewsTak.in`,
        description: `Maharashtra Vidhan Sabha Election Exit Polls: Find the Maharashtra Election exit polls results and latest update including महाराष्ट्र विधान सभा चुनाव, महाराष्ट्र विधान इलेक्शन एग्जिट पोल्स, महाराष्ट्र चुनाव एग्जिट पोल्स, महाराष्ट्र चुनाव एग्जिट पोल्स on NewsTak`,
        keywords: `Maharashtra Assembly Election Exit poll, 2024 Maharashtra Assembly Election Exit poll results, exit poll Maharashtra, exit poll results, Maharashtra vidhan sabha exit poll, Maharashtra exit poll, Maharashtra election result exit poll, Maharashtra assembly, Maharashtra election news, Maharashtra vidhan sabha election exit poll, Maharashtra latest exit poll, exit poll of Maharashtra, Maharashtra 2024 exit poll
    `,
      },
      state: "Maharashtra",
      stateHindi: "महाराष्ट्र",
      agencyName: "AgencyMB",

      exitDesc2019:
        "महाराष्ट्र विधानसभा चुनाव के लिए तैयारियां पूरी हो चुकी हैं. जल्द ही मतदान के बाद आ जाएंगे नतीजे. लेकिन नतीजों से पहले सबकी नजर रहेगी एग्जिट पोल्स पर. सबसे सटीक और तेज एग्जिट पोल्स के लिए जुड़े रहिए . तब तक जानिए 2019 के एग्जिट पोल्स. नीचे दी गई लिस्ट में मिलेगी सारी जानकारी.",
      exitDesc2024:
        "महाराष्ट्र विधानसभा चुनाव 2024 के नतीजे 23 अक्टूबर को आने वाले हैं, लेकिन उससे पहले एग्जिट पोल पर सबकी नजर है. हरियाणा चुनाव में सत्ताधारी बीजेपी के अलावा मुख्य विपक्षी कांग्रेस संग जेजेपी, आईएनएलडी और बसपा जैसी पार्टियां अपनी किस्मत आजमा चुकी हैं. चुनावी नतीजा ईवीएम में कैद हो चुका है. इस बार का चुनाव किसानों के मुद्दे, रोजगार और महंगाई जैसे इश्यू पर लड़ा गया. बीजेपी को 10 सालों की एंटी इनकंबेंसी का भी सामना करना पड़ा. एग्जिट पोल से हरियाणा चुनाव के संभावित नतीजों के बारे में पता चलता है. एग्जिट पोल के डेटा को वोटिंग के आखिरी दिन ही जारी किया जाता है. इसके लिए डेटा कलेक्शन वोटिंग के दिन किया जाता है. वोटिंग के दिन जब वोटर्स वोट डालकर बाहर आते हैं तो उनसे सवाल पूछकर नब्ज टटोली जाती है.",

      currentYear: "2024",
      2019: {
        type: "static",
        data: [
          {
            agency: "AgencyMB",
            pollData: [
              {
                agencyName: "India Today- Axis My India",
                partyData: [
                  {
                    partyName: "BJP",
                    seats: "109-124",
                    midRange: 116,
                    percentage: 48,
                  },
                  {
                    partyName: "SENA",
                    seats: "57-70",
                    midRange: 63,
                    percentage: 22,
                  },
                  {
                    partyName: "CONG",
                    seats: "32-40",
                    midRange: 36,
                    percentage: 12,
                  },
                  {
                    partyName: "NCP",
                    seats: "40-50",
                    midRange: 45,
                    percentage: 15,
                  },
                  {
                    partyName: "VBA",
                    seats: "00-02",
                    midRange: 1,
                    percentage: 1,
                  },
                  {
                    partyName: "OTH",
                    seats: "22-32",
                    midRange: 25,
                    percentage: 1,
                  },
                ],
              },
            ],
            totalSeats: 288,
          },
        ],
      },
      2024: {
        type: "api",
        data: "https://elections.mobiletak.com/jsonfiles/exitpolls/assemblyPollData.json",
        dataKey: "AgencyMB",
      },
      // "assemblyPollData": "https://elections.mobiletak.com/jsonfiles/exitpolls/assemblyPollData.json"
    },
    "key-candidates-list": {
      metaData: {
        title: `Maharashtra Election 2024: Key Candidates of Maharashtra Assembly Elections 2024, महाराष्ट्र विधान सभा चुनाव के प्रमुख उम्मीदवार - NewsTak`,
        description: `Get the list of Maharashtra Vidhan Sabha Chunav 2024 Key candidates (महाराष्ट्र विधान सभा चुनाव के प्रमुख उम्मीदवार), including party-wise candidates, constituencies, and महाराष्ट्र विधानसभा चुनाव उम्मीदवार in Hindi at NewsTak.in.
    `,
        keywords: `Maharashtra Election 2024 Key Candidate, Maharashtra Assembly Election 2024 Key Candidate, Maharashtra vidhan sabha chunav 2024 Candidate,Maharashtra 2024 candidate list, महाराष्ट्र विधान सभा चुनाव 2024 उम्मीदवारों की सूची, Vidhan Sabha Election Candidate, चुनाव समाचार
    `,
      },
      electionPassedCategory: "maharashtra-assembly",
      dataUrl:
        "https://electionresults.intoday.in/elections/2024/assembly-elections/json/ei-dashboard/2024/key-candidate/maharashtra-key-candidate.json",
      dataKey: "Maharashtra",
      dataUrlKey: "MH_KeyCandidatesURL",
      stateName: "Maharashtra",
      stateNameHi: "महाराष्ट्र",
      electionYear: "2024",
    },

    schedule: {
      electionPassedCategory: "maharashtra-assembly",
      state: "Maharashtra",
      stateHindi: "महाराष्ट्र",
      electionYear: "2024",
      metaData: {
        title: `Maharashtra Assembly Elections 2024: Maharashtra Vidhan Sabha Chunav 2024 Full Schedule, महाराष्ट्र विधान सभा चुनाव अनुसूची - NewsTak`,
        description: `Maharashtra Vidhan Sabha Elections 2024: Get complete details about the Maharashtra Assembly Elections 2024 Schedule (विधानसभा चुनाव 2024 अनुसूची), including voting dates, key candidates, and election result dates at NewsTak.`,
        keywords: `Maharashtra Assembly Election Schedule, Maharashtra Assembly Election polling dates, Maharashtra Assembly Election results date, Maharashtra Assembly Election candidates, महाराष्ट्र विधानसभा चुनाव परिणाम, चुनाव समाचार,Maharashtra elections updates`,
      },
      votingDate: "20 नवंबर 2024",
      resultDate: "23 नवंबर 2024",
      scheduleDesc:
        "288 सीटों वाले महाराष्ट्र विधानसभा के लिए 20 नंवबर को वोटिंग होगी और 23 नवंबर को मतगणना के बाद चुनाव परिणाम घोषित होंगे. महाराष्ट्र में महायुति और महाविकास अघाड़ी जैसे बड़े गठबंधन के अलावा बाकी पार्टियां जीत के लिए अपना पूरा दम लगाने में जुटी हैं. सत्तारूढ महायुति की सहयोगी पार्टी बीजेपी, शिवसेना (शिंदे), एनसीपी (अजित पवार) और इनके अन्य सहयोगी दल चुनावी मैदान में हैं. वहीं विपक्षी गठबंधन महाविकास अघाड़ी की सहयोगी पार्टी कांग्रेस, शिवसेना (उद्धव ठाकरे), एनसीपी (शरद पवार) समेत सहयोगी दल चुनाव लड़ रही हैं. इसके अलावा राज ठाकरे की मनसे के उम्मीदवार भी 25 सीटों पर ताल ठोंक चुके हैं. महाराष्ट्र की माहिम और वर्ली विधानसभा में चुनाव बेहद दिलचस्प हो गया है. इन सीटों पर राज ठाकरे की मनसे, शिंदे की शिवसेना और उद्धव की शिवसेना के बीच कड़ा मुकाबला हो गया है. महाराष्ट्र की 288 विधानसभा सीटों के लिए कुल 4,140 उम्मीदवार मैदान में हैं. सबसे कम उम्मीदवार नंदुरबार की शहादा सीट पर केवल 3 और बीड की माजलगांव सीट पर सबसे ज्यादा 34 उम्मीदवार हैं.",
    },
    results: {
      metaData: {
        title: `Maharashtra Election Results 2024 | महाराष्ट्र विधानसभा चुनाव परिणाम | Maharashtra Assembly Elections 2024 - NewsTak.in`,
        description: `Maharashtra Vidhan Sabha Election 2024 Results: Find the Maharashtra Assembly Election Results 2024 on NewsTak.in, including election result updates, महाराष्ट्र विधानसभा चुनाव परिणाम 2024, live vote counting, चुनाव विश्लेषण, वोटों की गिनती, चुनाव समाचार, पार्टी परिणाम, वीडियो, फोटो, विजेता उम्मीदवारों, and विधानसभा चुनाव नतीजे का कवरेज.`,
        keywords: `elections, election results, Maharashtra Assembly election results, maharashtra vidhan sabha chunav result, Maharashtra election results, Maharashtra election results live, Maharashtra assembly Election 2024 Result, counting of votes for Maharashtra Assembly Election, constituency wise result, Maharashtra election results, congress results updates, महाराष्ट्र विधानसभा चुनाव, 2024 महाराष्ट्र विधानसभा चुनाव परिणाम, चुनाव परिणाम, महाराष्ट्र चुनाव परिणाम, चुनाव 2024, विधानसभा चुनाव 2024 परिणाम,`,
      },
      electionPassedCategory: "maharashtra-assembly",
      state: "Maharashtra",
      stateHindi: "महाराष्ट्र",
      currentYear: "2024",
      oldResult: {
        partyData: [
          {
            color: "#FF9933",
            partyName: "Bharatiya Janata Party",
            partySeat: "132",
          },
          {
            color: "#19AAED",
            partyName: "Shiv Sena",
            partySeat: "57",
          },
          {
            color: "#19AAED",
            partyName: "Indian National Congress",
            partySeat: "16",
          },
          {
            color: "#71B218",
            partyName: "National Congress Party",
            partySeat: "41",
          },
          {
            color: "#CC0000",
            partyName: "OTH",
            partySeat: "44",
          },
        ],
      },
      resultKey: "partiesDataMH",
      oldDesc:
        "Maharashtra Assembly Elections Results 2024: इस बार के महाराष्ट्र विधानसभा चुनाव में कौन मारेगा बाजी? BJP, शिवसेना (शिंदे गुट) और NCP (अजित गुट) का महायुति गठबंधन को मिलेगा बहुमत या कांग्रेस, शिवसेना (उद्धव गुट) और NCP (शरद गुट) वाला महाअघाड़ी गठबंधन दोहराएगा 2024 लोकसभा चुनाव का प्रदर्शन? सबसे सटीक और तेज नतीजों के लिए बने रहिए न्यूज Tak के साथ. नीचे दी गई लिस्ट में जानिए 2019 के महाराष्ट्र विधानसभा चुनाव का रिजल्ट क्या रहा था.",
      newDesc:
        "Maharashtra Assembly Elections Results 2024: इस बार के महाराष्ट्र विधानसभा चुनाव में कौन मारेगा बाजी? BJP, शिवसेना (शिंदे गुट) और NCP (अजित गुट) का महायुति गठबंधन को मिलेगा बहुमत या कांग्रेस, शिवसेना (उद्धव गुट) और NCP (शरद गुट) वाला महाअघाड़ी गठबंधन दोहराएगा 2024 लोकसभा चुनाव का प्रदर्शन? सबसे सटीक और तेज नतीजों के लिए बने रहिए न्यूज Tak के साथ. ",
      prevDataUrl:
        "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/maharashtra-2014-all-consituency.json",
      currentDataUrl:
        "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/maharashtra-2019-all-consituency.json",
      2014: "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/maharashtra-2014-all-consituency.json",
      2019: "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/maharashtra-2019-all-consituency.json",
      // "2024" : "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/maharashtra-2019-all-consituency.json",
      2024: "https://electionresults.intoday.in/elections/2024/assembly-elections/json/state/maharashtra-all-consituency.json",
      constituency: {
        //this is used in url
        state: "Maharashtra",
        stateHindi: "महाराष्ट्र",
        url3Key: "ConstituencyDetailURL",
        url: "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/constituency/maharashtra/",
        // "url3": "https://electionresults.intoday.in/elections/2024/assembly-elections/json/constituency-tak/7047",
        url3: "https://electionresults.intoday.in/elections/2024/assembly-elections/json/constituency-tak/",
        url2: "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/maharashtra-state-master.json",
      },
    },
    "constituency-list": {
      electionPassedCategory: "maharashtra-assembly",
      state: "Maharashtra",
      stateHindi: "महाराष्ट्र",
            staticContent:`इस बार के महाराष्ट्र विधानसभा चुनाव में कौन मारेगा बाजी? BJP, शिवसेना (शिंदे गुट) और NCP (अजित गुट) का महायुति गठबंधन को मिलेगा बहुमत या कांग्रेस, शिवसेना (उद्धव गुट) और NCP (शरद गुट) वाला महाअघाड़ी गठबंधन दोहराएगा 2024 लोकसभा चुनाव का प्रदर्शन? सबसे सटीक और तेज नतीजों के लिए बने रहिए न्यूज Tak के साथ.`,

      currentYear: "2024",
      metaData: {
        title: `Maharashtra Assembly Election 2024: Constituency Wise Candidate Winner List, 2024 महाराष्ट्र विधानसभा चुनाव निर्वाचन क्षेत्र उम्मीदवार`,
        description: `Maharashtra Assembly Elections Results 2024 (महाराष्ट्र विधानसभा चुनाव 2024 परिणाम) – Get the list of winning candidates from all major parties in the Maharashtra vidhan sabha election (विधानसभा चुनाव) 2024, along with live election news, videos, photos, and in-depth analysis on Maharashtra Election 2024.`,
        keywords: `Maharashtra Assembly Election  2024, 2024 Maharashtra vidhan sabha election winning candidates list, Constituency-wise vidhan sabha Winning Candidates list 2024, winning candidates list of Maharashtra Assembly election 2024, महाराष्ट्र विधानसभा चुनाव 2024, महाराष्ट्र विधानसभा चुनाव 2024 उम्मीदवारों की सूची,  list of winning candidate, election results, जीतने वाला उम्मीदवार 2024,`,
      },
      constituency_urls: {
        //this is used in url
        state: "Maharashtra",
        stateHindi: "महाराष्ट्र",
        url3Key: "ConstituencyDetailURL",
        url: "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/constituency/maharashtra/",

        url3: "https://electionresults.intoday.in/elections/2024/assembly-elections/json/constituency-tak/",
        url2: "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/maharashtra-state-master.json",
      },
    },
    constituencies: {
      electionPassedCategory: "maharashtra-assembly",
      state: "Maharashtra",
      stateHindi: "महाराष्ट्र",
      currentYear: "2024",
    },
    tallyState: "maharashtra",
  },

  //jhanrkhand
  "jharkhand-assembly": {
    breadCrump: [
      {
        displayText: "खबरें",
        url: "/elections/jharkhand-assembly",
        keyToShow: "",
      },
      {
        displayText: "निर्वाचन क्षेत्र",
        url: "/elections/jharkhand-assembly/constituency-list",
        keyToShow: "",
      },

      {
        displayText: "प्रमुख उम्मीदवार",
        url: "/elections/jharkhand-assembly/key-candidates-list",
        keyToShow: "",
      },
      {
        displayText: "चुनाव परिणाम",
        url: "/elections/jharkhand-assembly/results",
        keyToShow: "",
      },
      {
        displayText: "एग्जिट पोल",
        url: "/elections/jharkhand-assembly/exit-poll-result",
        keyToShow: "",
      },

      {
        displayText: "शेड्यूल",
        url: "/elections/jharkhand-assembly/schedule",
        keyToShow: "",
      },
    ],
    masterConfigKey: "jharkhand_election",
    electionPassedCategory: "jharkhand-assembly",
    state: "Jharkhand",
    stateHindi: "झारखंड",
    masterConfigKey: "jharkhand_election",
    metaData: {
      title: `2024 Jharkhand Vidhan Sabha Chunav: Jharkhand Assembly Chunav 2024, झारखण्ड विधानसभा चुनाव, Jharkhand Elections Updates - NewsTak`,
      description: `Jharkhand Assembly Elections 2024: Find the latest updates on the 2024 Jharkhand Assembly Chunav (झारखण्ड विधानसभा चुनाव 2024), including voting dates, exit polls, election results, candidate profiles, photos, videos of झारखण्ड चुनाव 2024, and expert analysis at NewsTak.`,
      keywords: `Jharkhand chunav 2024, झारखण्ड विधानसभा चुनाव breaking News, Jharkhand assembly election 2024, Jharkhand assembly election news in hindi,झारखण्ड विधानसभा चुनाव परिणाम 2024, झारखण्ड चुनाव 2024, झारखण्ड चुनाव समाचार, झारखण्ड विधानसभा चुनाव समाचार`,
    },
    "exit-poll-result": {
      electionPassedCategory: "jharkhand-assembly",
      metaData: {
        title: `Exit Poll 2024 : Jharkhand Assembly Elections Exit poll, झारखण्ड विधानसभा चुनाव एग्जिट पोल्स - NewsTak.in`,
        description: `Jharkhand Vidhan Sabha Election Exit Polls: Find the Jharkhand Election exit polls results and latest update including झारखण्ड विधान सभा चुनाव, झारखण्ड विधान इलेक्शन एग्जिट पोल्स, झारखण्ड चुनाव एग्जिट पोल्स, झारखण्ड चुनाव एग्जिट पोल्स on NewsTak`,
        keywords: `Jharkhand Assembly Election Exit poll, 2024 Jharkhand Assembly Election Exit poll results, exit poll Jharkhand, exit poll results, Jharkhand vidhan sabha exit poll, Jharkhand exit poll, Jharkhand election result exit poll, Jharkhand assembly, Jharkhand election news, Jharkhand vidhan sabha election exit poll, Jharkhand latest exit poll, exit poll of Jharkhand, Jharkhand 2024 exit poll`,
      },
      state: "Jharkhand",
      stateHindi: "झारखंड",
      agencyName: "AgencyJH",

      exitDesc2019:
        "झारखंड विधानसभा चुनाव 2019 के नतीजे 21 दिसंबर को आने वाले हैं, लेकिन उससे पहले एग्जिट पोल पर सबकी नजर है. झारखंड चुनाव में सत्ताधारी बीजेपी के अलावा मुख्य विपक्षी कांग्रेस संग जेजेपी, आईएनएलडी और बसपा जैसी पार्टियां अपनी किस्मत आजमा रही हैं. इस बार का चुनाव किसानों के मुद्दे, रोजगार और महंगाई जैसे इश्यू पर लड़ा गया. बीजेपी को 10 सालों की एंटी इनकंबेंसी का भी सामना करना पड़ेगा. एग्जिट पोल से झारखंड चुनाव के संभावित नतीजों के बारे में पता चलता है. एग्जिट पोल के डेटा को वोटिंग के आखिरी दिन ही जारी किया जाता है. इसके लिए डेटा कलेक्शन वोटिंग के दिन किया जाता है. वोटिंग के दिन जब वोटर्स वोट डालकर बाहर आते हैं तो उनसे सवाल पूछकर नब्ज टटोली जाती है.",
      exitDesc2024:
        "झारखंड विधानसभा चुनाव 2024 के नतीजे 23 नवंबर को जारी होंगे. उससे पहले एग्जिट पोल पर सबकी नजर है. कुल 81 विधानसभा सीटों के लिए 1,211 उम्मीदवार मैदान में हैं. इसमें इंडिया ब्लॉक की तरफ से झामुमो के 43, कांग्रेस के 30, राजद के 6 और भाकपा-माले के 4 उम्मीदवारों के अलावा NDA के सहयोगी दल बीजेपी के 68, ऑल झारखंड स्टूडेंट्स यूनियन (AJSU) के 10, चिराग पासवान की पार्टी लोक जनशक्ति पार्टी (रामविलास) का 1 और नीतीश कुमार की जेडीयू (JDU) के 2 उम्मीदवार चुनावी समर में अपना भाग्य आजमा चुके हैं. चुनावी नतीजे ईवीएम में कैद हो चुके हैं. एग्जिट पोल से झारखंड चुनाव के संभावित नतीजों के बारे में पता चलता है. एग्जिट पोल के डेटा को वोटिंग के आखिरी दिन ही जारी किया जाता है. इसके लिए डेटा कलेक्शन वोटिंग के दिन किया जाता है. वोटिंग के दिन जब वोटर्स वोट डालकर बाहर आते हैं तो उनसे सवाल पूछकर जनता की नब्ज टटोली जाती है.",
      currentYear: "2024",
      2019: {
        type: "static",
        data: [
          {
            agency: "AgencyJH",
            pollData: [
              {
                agencyName: "CVoter",
                partyData: [
                  {
                    partyName: "BJP",
                    seats: "20-28",
                    midRange: 24,
                  },
                  {
                    partyName: "CONG+",
                    seats: "50-58",
                    midRange: 54,
                  },
                  {
                    partyName: "OTH",
                    seats: "10-16",
                    midRange: 13,
                  },
                ],
              },
            ],
            totalSeats: 82,
          },
        ],
      },
      2024: {
        type: "api",
        data: "https://elections.mobiletak.com/jsonfiles/exitpolls/assemblyPollData.json",
        dataKey: "AgencyJH",
      },
      // "assemblyPollData": "https://elections.mobiletak.com/jsonfiles/exitpolls/assemblyPollData.json"
    },
    "key-candidates-list": {
      metaData: {
        title: `Jharkhand Election 2024: Key Candidates of Jharkhand Assembly Elections 2024, झारखण्ड विधान सभा चुनाव के प्रमुख उम्मीदवार - NewsTak`,
        description: `Get the list of Jharkhand Vidhan Sabha Chunav 2024 Key candidates (झारखण्ड विधान सभा चुनाव के प्रमुख उम्मीदवार), including party-wise candidates, constituencies, and झारखण्ड विधानसभा चुनाव उम्मीदवार in Hindi at NewsTak.in.`,
        keywords: `Jharkhand Election 2024 Key Candidate, Jharkhand Assembly Election 2024 Key Candidate, Jharkhand vidhan sabha chunav 2024 Candidate,Jharkhand 2024 candidate list, झारखण्ड विधान सभा चुनाव 2024 उम्मीदवारों की सूची, Vidhan Sabha Election Candidate, चुनाव समाचार`,
      },
      electionPassedCategory: "jharkhand-assembly",
      dataUrl:
        "https://electionresults.intoday.in/elections/2024/assembly-elections/json/ei-dashboard/2024/key-candidate/jharkhand-key-candidate.json",
      dataKey: "Jharkhand",
      dataUrlKey: "JH_KeyCandidatesURL",
      stateName: "Jharkhand",
      stateNameHi: "झारखंड",
      electionYear: "2024",
    },

    schedule: {
      electionPassedCategory: "jharkhand-assembly",
      state: "Jharkhand",
      stateHindi: "झारखंड",
      electionYear: "2024",
      metaData: {
        title: `Jharkhand Assembly Elections 2024: Jharkhand Vidhan Sabha Chunav 2024 Full Schedule, झारखण्ड विधान सभा चुनाव अनुसूची - NewsTak`,
        description: `Jharkhand Vidhan Sabha Elections 2024: Get complete details about the Jharkhand Assembly Elections 2024 Schedule (विधानसभा चुनाव 2024 अनुसूची), including voting dates, key candidates, and election result dates at NewsTak.`,
        keywords: `Jharkhand Assembly Election Schedule, Jharkhand Assembly Election polling dates, Jharkhand Assembly Election results date, Jharkhand Assembly Election candidates, झारखण्ड विधानसभा चुनाव परिणाम, चुनाव समाचार,Jharkhand elections updates`,
      },
      votingDate: "20 नवंबर 2024",
      resultDate: "23 नवंबर 2024",
      scheduleDesc:
        "झारखंड की 81 विधानसभा सीटों के लिए चुनाव 13 और 20 नवंबर को दो चरणों में होंगे. मतगणना 23 नवंबर को होगी और इसी दिन रिजल्ट घोषित होगा. 43 विधानसभा क्षेत्रों में 13 नवंबर को पहले चरण का मतदान होगा. इन सीटों पर कुल 685 उम्मीदवार मैदान में हैं. जमशेदपुर पश्चिम विधानसभा क्षेत्र में सबसे अधिक 28 उम्मीदवार जबकि जगन्नाथपुर में सबसे कम 8 उम्मीदवार मैदान में हैं. दूसरे चरण की 38 विधानसभा सीटों पर 528 उम्मीदवार मैदान में हैं. धनवार विधानसभा क्षेत्र में सबसे अधिक 24 उम्मीदवार जबकि देवघर में सबसे कम 7 उम्मीदवार मैदान में है. दूसरे चरण में 20 नवंबर को मतदान होगा. कुल 81 विधानसभा सीट के लिए 1,211 उम्मीदवार मैदान में हैं. इसमें इंडिया ब्लॉक की तरफ से झामुमो ने 43, कांग्रेस ने 30, राजद ने 6 और भाकपा-माले ने 4 सीटों पर अपने उम्मीदवार उतारे हैं. वहीं NDA के सहयोगी दल बीजेपी 68 सीटों पर पर, ऑल झारखंड स्टूडेंट्स यूनियन (AJSU) 10 सीटों पर, नीतीश कुमार की जेडीयू (JDU) 2 सीटों पर और चिराग पासवान की पार्टी लोक जनशक्ति पार्टी (रामविलास) 1 सीट पर मैदान में है. झामुमो और कांग्रेस 2014 में अलग-अलग लड़े तो केवल 25 सीटें ही जीत सके, लेकिन 2019 में जब वे एक साथ लड़े तो उनकी सीटों की संख्या बढ़कर 47 हो गई. वहीं भाजपा 2019 में अकेले लड़ी तो केवल 25 सीटें हासिल कर सकी. जबकि 2014 में आजसू के साथ गठबंधन में लड़ते हुए उन्हें 42 सीटें हासिल हुई थी.",
    },
    results: {
      metaData: {
        title: `Jharkhand Assembly Elections Results 2024 | झारखंड विधानसभा चुनाव परिणाम | Jharkhand Election Results - NewsTak.in`,
        description: `Jharkhand Election 2024 Results (झारखंड विधानसभा चुनाव परिणाम): Find the latest news on Jharkhand Assembly Election 2024 result date. Get updates on Jharkhand Chunav 2024 Parinaam, live vote counting, assembly polls, and winner name at NewsTak.in`,
        keywords: `elections, election results, Jharkhand Assembly election results, maharashtra vidhan sabha chunav result, Jharkhand election results, Jharkhand election results live, Jharkhand assembly Election 2024 Result, counting of votes for Jharkhand Assembly Election, constituency wise result, Jharkhand election results, constituency wise result, झारखंड विधानसभा चुनाव, 2024 झारखंड विधानसभा चुनाव परिणाम, चुनाव परिणाम, झारखंड चुनाव परिणाम, चुनाव 2024, विधानसभा चुनाव 2024 परिणाम,`,
      },
      electionPassedCategory: "jharkhand-assembly",
      state: "Jharkhand",
      stateHindi: "झारखंड",
      currentYear: "2024",
      oldResult: {
        partyData: [
          {
            color: "#FF9933",
            partyName: "Bharatiya Janata Party",
            partySeat: "21",
          },
          {
            color: "#19AAED",
            partyName: "Jharkhand Mukti Morcha",
            partySeat: "34",
          },
          {
            color: "#19AAED",
            partyName: "Indian National Congress",
            partySeat: "16",
          },
           
          {
            color: "#19AAED",
            partyName: "Rashtriya Janata Dal",
            partySeat: "04",
          },
          {
            color: "#CC0000",
            partyName: "OTH",
            partySeat: "06",
          },
        ],
      },
      resultKey: "partiesDataJH",
      oldDesc:
        "Jharkhand Assembly Elections Results 2024: इस बार के झारखंड विधानसभा चुनाव में चल रही है किसकी हवा? JMM-कांग्रेस का INDIA गठबंधन बचा लेगा अपनी सरकार या BJP-AJSU वाला NDA गठबंधन मार ले जाएगा बाजी? सबसे सटीक और तेज नतीजों के लिए बने रहिए न्यूज Tak के साथ. नीचे दी गई लिस्ट में जानिए क्या रहा था झारखंड विधानसभा चुनाव 2019 का रिजल्ट.",
      newDesc:
        "Jharkhand Assembly Elections Results 2024: इस बार के झारखंड विधानसभा चुनाव में चल रही है किसकी हवा? JMM-कांग्रेस का INDIA गठबंधन बचा लेगा अपनी सरकार या BJP-AJSU वाला NDA गठबंधन मार ले जाएगा बाजी? सबसे सटीक और तेज नतीजों के लिए बने रहिए न्यूज Tak के साथ. ",
      prevDataUrl:
        "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/jharkhand-2014-all-consituency.json",
      currentDataUrl:
        "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/jharkhand-2019-all-consituency.json",
      2014: "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/jharkhand-2014-all-consituency.json",
      2019: "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/jharkhand-2019-all-consituency.json",
      // "2024" : "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/jharkhand-2019-all-consituency.json",
      2024: "https://electionresults.intoday.in/elections/2024/assembly-elections/json/state/jharkhand-all-consituency.json",
      constituency: {
        //this is used in url
        state: "Jharkhand",
        stateHindi: "झारखंड",
        url3Key: "ConstituencyDetailURL",
        url: "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/constituency/jharkhand/",
        // "url3": "https://electionresults.intoday.in/elections/2024/assembly-elections/json/constituency-tak/7047",
        url3: "https://electionresults.intoday.in/elections/2024/assembly-elections/json/constituency-tak/",
        url2: "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/jharkhand-state-master.json",
      },
    },
    "constituency-list": {
      electionPassedCategory: "jharkhand-assembly",
      state: "Jharkhand",
      stateHindi: "झारखंड",
            staticContent:` इस बार के झारखंड विधानसभा चुनाव में चल रही है किसकी हवा? JMM-कांग्रेस का INDIA गठबंधन बचा लेगा अपनी सरकार या BJP-AJSU वाला NDA गठबंधन मार ले जाएगा बाजी? सबसे सटीक और तेज नतीजों के लिए बने रहिए न्यूज Tak के साथ.`,

      currentYear: "2024",
      metaData: {
        title: `Jharkhand Assembly Election 2024: Constituency Wise Candidate Winner List, 2024 झारखंड विधानसभा चुनाव निर्वाचन क्षेत्र उम्मीदवार`,
        description: `Jharkhand Assembly Elections Results 2024 (झारखंड विधानसभा चुनाव 2024 परिणाम) – Get the list of winning candidates from all major parties in the Jharkhand vidhan sabha election (विधानसभा चुनाव) 2024, along with live election news, videos, photos, and in-depth analysis on Jharkhand Election 2024.`,
        keywords: `Jharkhand Assembly Election  2024, 2024 Jharkhand vidhan sabha election winning candidates list, Constituency-wise vidhan sabha Winning Candidates list 2024, winning candidates list of Jharkhand Assembly election 2024, झारखंड विधानसभा चुनाव 2024, झारखंड विधानसभा चुनाव 2024 उम्मीदवारों की सूची,  list of winning candidate, election results, जीतने वाला उम्मीदवार 2024,`,
      },
      constituency_urls: {
        //this is used in url
        state: "Jharkhand",
        stateHindi: "झारखंड",
        url3Key: "ConstituencyDetailURL",
        url: "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/constituency/jharkhand/",

        url3: "https://electionresults.intoday.in/elections/2024/assembly-elections/json/constituency-tak/",
        url2: "https://akm-img-a-in.tosshub.com/sites/elections/2024/assembly/json/state-master/jharkhand-state-master.json",
      },
    },
    constituencies: {
      electionPassedCategory: "jharkhand-assembly",
      state: "Jharkhand",
      stateHindi: "झारखंड",
      currentYear: "2024",
    },
    tallyState: "jharkhand",
  },
};
